import { decimalPlaceDropdownOption, proposalByDropdownOption, roundMethodDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { StandardProposalConstant } from "presentation/constant/StandardProposal/StandardProposalConstant";
import { useStandardProposalVM } from "presentation/hook/StandardProposal/useStandardProposalVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useStandardProposalTracked } from "presentation/store/StandardProposal/StandardProposalProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DatePickerComponent from "presentation/view/components/DatePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { memo, useCallback, useMemo } from "react";
import { FieldType, IconButton, IFieldValue } from "veronica-ui-component/dist/component/core";
import { SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";


const UpdatePercentageAndProposalNoPanel: React.FC = () => {

    const STANDARD_PROPOSAL_CONSTANT = StandardProposalConstant.Table;
    const [standardProposalState] = useStandardProposalTracked();
    const standardProposalVM = useStandardProposalVM();
    const messageBarVM = useMessageBarVM();
    const { isEditPercentage, isEditProposalNo, isEditNewProposalNo, copyToEditPercentage, copyToEditProposalNo, copyToEditNewProposal, stdProposalState } = standardProposalState;
    const { isSaveClicked, allFormState } = stdProposalState;
    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        standardProposalVM.onCopyPercentageFieldChange(fieldName, fieldValue);
    }, [standardProposalVM]);

    const handClose = useCallback(() => {
        standardProposalVM.onTariffItemCopyEditCloseClick();
    }, [standardProposalVM]);

    const handSave = useCallback(() => {
        if (isEditPercentage) {
            standardProposalVM.onSaveClicked();
            standardProposalVM.onCopyEditPercentageSaveClick(copyToEditPercentage);
        }
        if (isEditProposalNo) {
            standardProposalVM.onSaveClicked();
            standardProposalVM.onCopyEditProposalNoSaveClick(copyToEditProposalNo);
        }
        if (isEditNewProposalNo) {
            // if (!copyToEditNewProposal.effectiveDate) {
            //     messageBarVM.showError("Effective Date is mandatory.");
            //     return;
            // }
            // if (!copyToEditNewProposal.expiryDate) {
            //     messageBarVM.showError("Expiry Date is mandatory.");
            //     return;
            // }
            if (copyToEditNewProposal.effectiveDate && copyToEditNewProposal.expiryDate && new Date(copyToEditNewProposal.expiryDate) < new Date(copyToEditNewProposal.effectiveDate)) {
                messageBarVM.showError("The Expiry Date must be greater than the Effective Date.");
                return;
            }
            // if (!copyToEditNewProposal.currencyCode) {
            //     messageBarVM.showError("Currency is mandatory.");
            //     return;
            // }
            // if (!copyToEditNewProposal.proposalCreatedByMethod) {
            //     messageBarVM.showError("Proposal By is mandatory.");
            //     return;
            // }
            standardProposalVM.onSaveClicked();
            standardProposalVM.onCopyEditNewProposalNoSaveClick(copyToEditNewProposal);
        }
    }, [isEditPercentage, isEditProposalNo, isEditNewProposalNo, standardProposalVM, copyToEditPercentage, copyToEditProposalNo, copyToEditNewProposal, messageBarVM]);

    const memoTariffType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "10px", marginLeft: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={copyToEditPercentage.tariffType || ''}
                fieldValue={copyToEditPercentage.tariffType}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.TARIFF_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tariffType'}
                maxLength={60}
                options={standardProposalState.dynamicOptions.tariffTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalVM.onCopyPercentageFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.TARIFF_TYPE, allFormState, copyToEditPercentage.tariffType, isSaveClicked, standardProposalState.dynamicOptions.tariffTypeDropdownOptions, standardProposalVM])

    const memoChargePercentage = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "10px", marginLeft: "20px" }}>
            <NumberInputComponent
                label={STANDARD_PROPOSAL_CONSTANT.CHARGE_PERCENTAGE}
                maxLength={10}
                fieldName={"chargePercentage"}
                value={copyToEditPercentage.chargePercentage ?? ''}
                errorMessage={allFormState ? allFormState["chargePercentage"] ?? "" : ""}
                disabled={false}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.CHARGE_PERCENTAGE, allFormState, copyToEditPercentage.chargePercentage, onNumberFieldChange])

    const memoRoundMethod = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "10px", marginLeft: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={copyToEditPercentage.roundMethod || ''}
                fieldValue={copyToEditPercentage.roundMethod}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.ROUND_METHOD}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'roundMethod'}
                maxLength={60}
                options={roundMethodDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalVM.onCopyPercentageFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.ROUND_METHOD, allFormState, copyToEditPercentage.roundMethod, isSaveClicked, standardProposalVM])

    const memoDecimalPlace = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "10px", marginLeft: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={copyToEditPercentage.decimalPlace || ''}
                fieldValue={copyToEditPercentage.decimalPlace}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.DECIMAL_PLACE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'decimalPlace'}
                maxLength={60}
                options={decimalPlaceDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalVM.onCopyPercentageFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.DECIMAL_PLACE, allFormState, copyToEditPercentage.decimalPlace, isSaveClicked, standardProposalVM])


    const memoCompanyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "10px", marginLeft: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={copyToEditProposalNo.companyCode || ''}
                fieldValue={copyToEditProposalNo?.companyCode}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.COMPANY_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'companyCode'}
                maxLength={60}
                isLimitOptions={true}
                options={standardProposalState.dynamicOptions.companyCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalVM.onCopyProposalNoFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.COMPANY_CODE, allFormState, copyToEditProposalNo.companyCode, isSaveClicked, standardProposalState.dynamicOptions.companyCodeDropdownOptions, standardProposalVM])

    const memoProposalNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "10px", marginLeft: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={copyToEditProposalNo.proposalNo || ''}
                fieldValue={copyToEditProposalNo.proposalNo}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.PROPOSAL_NO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'proposalNo'}
                maxLength={60}
                requiredFieldList={[]}
                options={standardProposalState.dynamicOptions.companyCodeProposalNoDropdownOptions}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalVM.onCopyProposalNoFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.PROPOSAL_NO, allFormState, copyToEditProposalNo.proposalNo, isSaveClicked, standardProposalState.dynamicOptions.companyCodeProposalNoDropdownOptions, standardProposalVM])

    const memoNewCompanyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "10px", marginLeft: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={copyToEditNewProposal?.companyCode || ''}
                fieldValue={copyToEditNewProposal?.companyCode}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.COMPANY_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'companyCode'}
                maxLength={60}
                isLimitOptions={true}
                options={standardProposalState.dynamicOptions.companyCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalVM.onCopyNewProposalNoFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.COMPANY_CODE, allFormState, copyToEditNewProposal?.companyCode, isSaveClicked, standardProposalState.dynamicOptions.companyCodeDropdownOptions, standardProposalVM])

    const memoEffectiveDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "10px", marginLeft: "20px" }}>
            <DatePickerComponent
                disabled={false}
                label={STANDARD_PROPOSAL_CONSTANT.EFFECTIVE_DATE}
                width="185px"
                date={copyToEditNewProposal.effectiveDate}
                fieldName="effectiveDate"
                errorMessage={allFormState ? allFormState["effectiveDate"] ?? "" : ""}
                onDateChange={standardProposalVM.onCopyNewProposalNoFieldChange} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.EFFECTIVE_DATE, allFormState, copyToEditNewProposal.effectiveDate, standardProposalVM.onCopyNewProposalNoFieldChange])

    const memoExpiryDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "10px", marginLeft: "20px" }}>
            <DatePickerComponent
                disabled={false}
                label={STANDARD_PROPOSAL_CONSTANT.EXPIRY_DATE}
                width="185px"
                date={copyToEditNewProposal.expiryDate}
                fieldName="expiryDate"
                errorMessage={allFormState ? allFormState["expiryDate"] ?? "" : ""}
                onDateChange={standardProposalVM.onCopyNewProposalNoFieldChange} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.EXPIRY_DATE, allFormState, copyToEditNewProposal.expiryDate, standardProposalVM.onCopyNewProposalNoFieldChange])

    const memoCurrency = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "10px", marginLeft: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={copyToEditNewProposal?.currencyCode || ''}
                fieldValue={copyToEditNewProposal?.currencyCode}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.CURRENCY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'currencyCode'}
                maxLength={60}
                options={standardProposalState.dynamicOptions.currencyCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalVM.onCopyNewProposalNoFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.CURRENCY, allFormState, copyToEditNewProposal?.currencyCode, isSaveClicked, standardProposalState.dynamicOptions.currencyCodeDropdownOptions, standardProposalVM])

    const memoProposalBy = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "10px", marginLeft: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={copyToEditNewProposal.proposalCreatedByMethod || ''}
                fieldValue={copyToEditNewProposal?.proposalCreatedByMethod}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.PROPOSAL_BY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'proposalCreatedByMethod'}
                maxLength={60}
                options={proposalByDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalVM.onCopyNewProposalNoFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.PROPOSAL_BY, allFormState, copyToEditNewProposal.proposalCreatedByMethod, isSaveClicked, standardProposalVM])

    const memoRemarks = useMemo(() =>
        <div className='im-flex-row-item' id="std-proposal-edit-remarks" style={{ width: "420px", marginBottom: "10px", marginLeft: "20px" }} >
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={copyToEditNewProposal?.remarks || ''}
                fieldValue={copyToEditNewProposal.remarks}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.REMARKS}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'remarks'}
                maxLength={1333}
                rows={1}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalVM.onCopyNewProposalNoFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)}
            />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.REMARKS, allFormState, copyToEditNewProposal.remarks, isSaveClicked, standardProposalVM])

    const memoOperatingTml = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "10px", marginLeft: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={copyToEditNewProposal.operatingTml || ''}
                fieldValue={copyToEditNewProposal.operatingTml}
                fieldLabel={STANDARD_PROPOSAL_CONSTANT.OPERATING_TML}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'operatingTml'}
                maxLength={60}
                options={standardProposalState.dynamicOptions.operatingTmlDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    standardProposalVM.onCopyNewProposalNoFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [STANDARD_PROPOSAL_CONSTANT.OPERATING_TML, allFormState, copyToEditNewProposal.operatingTml, isSaveClicked, standardProposalState.dynamicOptions.operatingTmlDropdownOptions, standardProposalVM])


    return <>
        <div className={'flex-row'} style={{ overflow: "visible", zIndex: "100" }}>
            <div className={'flex-row-item flex-row-item-full-width'} >
                <Sidebarheader>
                    <SidebarTitle></SidebarTitle>
                    <SidebarActionCross>
                        <IconButton
                            fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={handClose} />
                        <IconButton
                            fileName="Icon-tick" size="medium" toolTipText='Save' toolTipArrow={false} onClick={handSave} />
                    </SidebarActionCross>
                </Sidebarheader>
            </div>


            {isEditPercentage && <>
                <CriteriaItemContainer>
                    {memoTariffType}
                    {memoChargePercentage}
                    {/* </CriteriaItemContainer>

                <CriteriaItemContainer> */}
                    {memoRoundMethod}
                    {memoDecimalPlace}
                </CriteriaItemContainer></>}

            {isEditProposalNo && <>
                <CriteriaItemContainer>
                    {memoCompanyCode}
                    {memoProposalNo}
                </CriteriaItemContainer></>}

            {isEditNewProposalNo && <>
                <CriteriaItemContainer>
                    {memoNewCompanyCode}
                    {memoEffectiveDate}
                    {memoExpiryDate}
                    {memoCurrency}
                    {memoProposalBy}
                    {memoOperatingTml}
                    {memoRemarks}
                </CriteriaItemContainer></>}
        </div>
    </>;
}

export default memo(UpdatePercentageAndProposalNoPanel);
